module.exports = __webpack_public_path__ + "img/jiaowu1.3ce69a49.jpg";